import styled from "styled-components";

const SelectedImageWrapper = styled.img`
display: inline;
width: 40px;
height: 40px;
border-radius: 20px;
flex-shrink: 0;
`

const UnselectedImageWrapper = styled.img`
position:absolute;
top:25%;
left:25%;
width:20px;
height:20px;
flex-shrink: 0;
`

export { SelectedImageWrapper, UnselectedImageWrapper }